import { createAsyncThunk } from '@reduxjs/toolkit'

import { IWalletEvent, IWalletEventMetadata } from 'meta/pages/v4/wallet'
import { WalletController } from 'controller/wallet'
import { RootState } from 'store/types'

type Params = { page: number }

type Returned = { goodsServices: Array<IWalletEvent>; metadata: IWalletEventMetadata }

export const getUpcomingGoodsServices = createAsyncThunk<Returned, Params, { state: RootState }>(
  'wallet/goods-services',
  async (params) => {
    const { page } = params

    const { items, metadata } = await WalletController.getUpcomingGoodsServices({ page })

    return { goodsServices: items, metadata }
  }
)
